module.exports = __webpack_public_path__ + "static/media/2.8.d738dab0.png";